<div style="width: calc(100vw - 300px); position: fixed;" class="d-flex justify-content-center align-items-center h-100">
  <div class="loader-container d-flex justify-content-center">
    <!-- <div class="loader">
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="orbit-container">
          <div class="orbit-dot"></div>
          <div class="orbit-dot"></div>
          <div class="orbit-dot"></div>
          <div class="orbit-dot"></div>
      </div>
    </div> -->
    <!-- <div class="app">
      <div class="circle">
        <div class="border-circle border-circle-up"></div>
        <div class="border-circle border-circle-left"></div>
        <div class="border-circle border-circle-right"></div>
        <div class="border-circle border-circle-down"></div>
      </div>
    </div> -->
    <!-- <div class="loader-text">
      <h6>Loading...</h6>
  </div> -->
  <!-- From Uiverse.io by dexter-st -->
<div class="loader-wrapper">
  <!-- <span class="loader-letter">L</span>
  <span class="loader-letter">o</span>
  <span class="loader-letter">a</span>
  <span class="loader-letter">d</span>
  <span class="loader-letter">i</span>
  <span class="loader-letter">n</span>
  <span class="loader-letter">g</span> -->

  <div class="loader"></div>
</div>

  </div>
